import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../../constants/constants";

/**
 * Legacy route: the OTP login is now part of the unified /auth/login page
 * (Phone tab). Redirect here so old links / bookmarks still land somewhere
 * useful.
 */
export const OtpLoginPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`/auth/${LOGIN}`, { replace: true });
  }, [navigate]);
  return null;
};
